import { ServiceAndInfra } from './type'

export function newServiceAndInfra(): ServiceAndInfra {
    return {
        id: undefined,
        road: false,
        status_n_quality: null,
        access_points: null,
        length_of_road: null,
        ownership: null,

        central_heating: false,
        heatings: [],
        other_heating: null,

        all_of_it: false,
        services: [],
        other_service: null,

        ownership_of_common_areas_id: null,
        utilities_connection_status_id: null,
        electrical_option_id: null,
        electrical_condition_id: null,
        water_option_id: null,
        water_condition_id: null,
        drainage_option_id: null,
        drainage_condition_id: null,
        elevators_option_id: null,
        elevators_condition_id: null,
        air_conditioning_option_id: null,
        air_conditioning_condition_id: null
    }
}